import { h, FunctionComponent } from 'preact'

export const SunIcon: FunctionComponent = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.32406 15.9993C9.32406 19.6807 12.3187 22.6754 16.0001 22.6754C19.6814 22.6754 22.6761 19.6807 22.6761 15.9993C22.6761 12.318 19.6814 9.32335 16.0001 9.32335C12.3187 9.32335 9.32406 12.318 9.32406 15.9993ZM16.0001 11.99C18.2107 11.99 20.0094 13.7887 20.0094 15.9993C20.0094 18.21 18.2107 20.0087 16.0001 20.0087C13.7894 20.0087 11.9907 18.21 11.9907 15.9993C11.9907 13.7887 13.7894 11.99 16.0001 11.99ZM14.6641 25.3327H17.3307V29.3327H14.6641V25.3327ZM14.6641 2.66602H17.3307V6.66602H14.6641V2.66602ZM2.66406 14.666H6.66406V17.3327H2.66406V14.666ZM25.3307 14.666H29.3307V17.3327H25.3307V14.666ZM5.6254 24.4834L8.45206 21.654L10.3387 23.5394L7.51206 26.3687L5.6254 24.4834ZM21.6534 8.45802L24.4827 5.62868L26.3681 7.51402L23.5387 10.3433L21.6534 8.45802ZM8.45606 10.3447L5.62673 7.51535L7.5134 5.63002L10.3401 8.45935L8.45606 10.3447ZM26.3681 24.4847L24.4827 26.37L21.6534 23.5407L23.5387 21.6553L26.3681 24.4847Z"
        fill="#2B2D33"
      />
    </svg>
  )
}
